import JourneyPlanner from '../../pages/JourneyPlanner'

export default function Panel() {
  return <JourneyPlanner />
}
